export default __webpack_public_path__ + "aca60bfdd405fc6660feaf1705750f22.png";